<ng-container *ngIf="showClientNfs">
	<p-accordion [activeIndex]="-1" (onOpen)="loadMsgs()">
		<p-accordionTab>
			<p-header>
				<div class="history-header">Client Nfs</div>
			</p-header>

			<div class="tasks-list">

				<ng-container *ngIf="msgLoading">
					<lib-progress-spinner></lib-progress-spinner>
				</ng-container>

				<div class="tasks-container" *ngIf="!msgLoading">
					<div class="nfs-block" *ngFor="let clientNf of clientNfs">
						<app-client-message [clientNf]="clientNf" [ngClass]="{'resolved-nfs': clientNf.resolvedTime}"
							[isMobile]="isMobile" [fromProj]="true" (deleteMsg)="deleteMsg($event)">
						</app-client-message>
					</div>
					<div class="nfs-block no-history" *ngIf="!clientNfs?.length">
						No Messages
					</div>

					<button mat-button class="create-message-button" (click)="createMessage()">
						<mat-icon>add</mat-icon>
						<div class="button-title">Create Message</div>
					</button>
				</div>
			</div>

		</p-accordionTab>
	</p-accordion>
</ng-container>